import React from "react";
import axios from "axios";
import { Button, Box, Typography } from '@mui/material';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const DownloadTxtButtonComponent = () => {


    const { user } = useSelector((state) => state.user);
    const token = user.token;
    
    
  const handleDownload = async () => {
    try {
        var config = {
          method: "GET",
          url: process.env.REACT_APP_API_URL + `/downloadtxt`,
          headers: {
            authtoken: "bearer " + token,
          },
          responseType: "blob",
        };
        const response = await axios(config);
  
        //If response is successful, initiate the download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "createuser.txt");
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        if (error.response && error.response.status === 500) {
          // If file is not found, show an error toast
          toast.error("File not found. Please upload the template.");
        } else {
          // Handle other errors
          toast.error("An error occurred while downloading the template");
        }
      }
  };

  return (
    <Box sx={{margin:'20px'}}>
         {/* <p> ดาวน์โหลดไฟล์ createuser.txt</p> */}
    <Button
      variant="contained"
      color="primary"
      startIcon={<FileDownloadIcon />}
      onClick={handleDownload}
    >
      ดาวน์โหลดไฟล์ createuser.txt
    </Button>
     </Box>
  );
};

export default DownloadTxtButtonComponent;
